import * as React from 'react';

import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { cva } from 'class-variance-authority';

import { cn } from '../lib/utils';

const tooltipVariants = cva(
  'vai-z-[9999] vai-overflow-hidden vai-rounded-md vai-border vai-bg-popover vai-px-3 vai-py-1.5 vai-text-sm vai-text-popover-foreground vai-shadow-md vai-animate-in vai-fade-in-0 vai-zoom-in-95 data-[state=closed]:vai-animate-out data-[state=closed]:vai-fade-out-0 data-[state=closed]:vai-zoom-out-95 data-[side=bottom]:vai-slide-in-from-top-2 data-[side=left]:vai-slide-in-from-right-2 data-[side=right]:vai-slide-in-from-left-2 data-[side=top]:vai-slide-in-from-bottom-2',
  {
    variants: {
      variant: {
        default:
          'vai-z-[9999] vai-overflow-hidden vai-rounded-md vai-border vai-bg-popover vai-px-3 vai-py-1.5 vai-text-sm vai-text-popover-foreground vai-shadow-md vai-animate-in vai-fade-in-0 vai-zoom-in-95 data-[state=closed]:vai-animate-out data-[state=closed]:vai-fade-out-0 data-[state=closed]:vai-zoom-out-95 data-[side=bottom]:vai-slide-in-from-top-2 data-[side=left]:vai-slide-in-from-right-2 data-[side=right]:vai-slide-in-from-left-2 data-[side=top]:vai-slide-in-from-bottom-2',
        dark: 'vai-z-[9999] vai-overflow-hidden vai-rounded-md vai-border vai-border-zinc-800 !vai-bg-background-dark vai-px-3 vai-py-1.5 vai-text-sm vai-text-foreground-dark vai-font-inter vai-text-popover-foreground vai-shadow-md vai-animate-in vai-fade-in-0 vai-zoom-in-95 data-[state=closed]:vai-animate-out data-[state=closed]:vai-fade-out-0 data-[state=closed]:vai-zoom-out-95 data-[side=bottom]:vai-slide-in-from-top-2 data-[side=left]:vai-slide-in-from-right-2 data-[side=right]:vai-slide-in-from-left-2 data-[side=top]:vai-slide-in-from-bottom-2 [&>p]:vai-text-sm [&>p]:vai-font-inter [&>p]:vai-font-medium [&>p]:vai-text-foreground-dark [&>span]:vai-text-sm [&>span]:vai-font-inter [&>span]:vai-font-medium [&>span]:vai-text-foreground-dark',
      },
    },
  },
);

const TooltipProvider = TooltipPrimitive.Provider;

const Tooltip = TooltipPrimitive.Root;

const TooltipTrigger = TooltipPrimitive.Trigger;

const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content> & {
    portal?: boolean;
    variant?: 'default' | 'dark';
  }
>(
  (
    {
      className,
      sideOffset = 4,
      portal = false,
      variant = 'default',
      ...props
    },
    ref,
  ) => {
    return portal ? (
      <TooltipPrimitive.Portal>
        <TooltipPrimitive.Content
          ref={ref}
          sideOffset={sideOffset}
          className={cn(tooltipVariants({ variant }), className)}
          {...props}
        />
      </TooltipPrimitive.Portal>
    ) : (
      <TooltipPrimitive.Content
        ref={ref}
        sideOffset={sideOffset}
        className={cn(tooltipVariants({ variant }), className)}
        {...props}
      />
    );
  },
);
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
